import './scss/style.scss'

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useSearchParams } from 'react-router-dom'

import Login from './views/Login';
import Dashboard from './views/Dashboard';
import BoardMaster from './views/BoardMaster';
import ErrorPage from "./views/ErrorPage";
import SnackbarProvider from 'react-simple-snackbar'
import ExamMaster from './views/ExamMaster';
import GradeMaster from './views/GradeMaster';
import StreamMaster from './views/StreamMaster';
import CourseMaster from './views/CourseMaster';
import QuestionTypeMaster from './views/QuestionTypeMaster';
import SubjectMaster from './views/SubjectMaster';
import PublicationMaster from './views/PublicationMaster';
import SyllabusTypeMaster from './views/SyllabusTypeMaster';
import SyllabusMaster from './views/SyllabusMaster';
import LessonMaster from './views/LessonMaster';
import TopicMaster from './views/TopicMaster';
import { AuthProvider, useAuth } from './context/AuthContext';
import SubtopicMaster from './views/SubtopicMaster';
import InstituteMaster from './views/InstituteMaster';
import InstituteLogin from './views/Institute/InstituteLogin';
import SectionMaster from './views/Institute/SectionMaster';
import InstituteDashboard from './views/Institute/InstituteDashboard';
import SectionDashboard from './views/section/SectionDashboard';
import InstituteList from './views/InstituteList';
import SectionLogin from './views/section/SectionLogin';
import TeacherMaster from './views/section/TeacherMaster';
import InstituteGradeMaster from './views/Institute/InstituteGradeMaster';
import InstituteSubjectMaster from './views/Institute/InstituteSubjectMaster';
import InstituteDivisionMaster from './views/Institute/InstituteDivisionMaster';
import TeacherMapping from './views/section/TeacherMapping';
import RegisterTeacherList from './views/section/RegisterTeacherList';
import UploadPdfBookMaster from './views/UploadPdfBookMaster';
import ImportStudent from './views/section/ImportStudent';
import UnaprovedStudentList from './views/section/UnaprovedStudentList';
import InstituteSyllabusStructrure from './views/Institute/InstitudeSyllabusStructure';
import InstitutePdfUpload from './views/Institute/InstitutePdfUpload';
import SectionSyllabusStructure from './views/section/SectionSyllabusStructure';
import SectionUploadPdfMaster from './views/section/SectionUploadPdfMaster';
import SectionAllStudentList from './views/section/SectionAllStudentList';
import AdminAllStudent from './views/AdminAllStudent';
import SectionLessonMaster from './views/section/SectionLessonMaster';
import SectionTopicMaster from './views/section/SectionTopicMaster';
import SectionSubtopicMaster from './views/section/SectionSubTopicMaster';
import InstituteLessonMaster from './views/Institute/InstituteLessonMaster';
import InstituteTopicMaster from './views/Institute/InstituteTopicMaster';
import InstituteSubTopicMaster from './views/Institute/InstituteSubTopicMaster';
import SectionSidebar from './components/SectionSidebar';
import InstituteSidebar from './components/InstituteSidebar';
import Sidebar from './components/Sidebar';
import ViewPdfBook from './views/ViewPdfBook';
import SectionViewPdfBook from './views/section/SectionViewPdfBook';
import InstituteViewPdfBook from './views/Institute/InstituteViewPdfBook';
import InstituteUpdateTextBook from './views/Institute/InstituteUpdateTextBook';
import InstituteViewTextBook from './views/Institute/InstituteViewTextBook';
import InstituteUploadContentTextBook from './views/Institute/InstituteUploadContentTextBook';
import IntituteGradeForApproval from './views/IntituteGradeForApproval';
import InstituteSubjectForApproval from './views/InstituteSubjectForApproval';
import TagMaster from './views/TagMaster';
import SectionTagMaster from './views/section/SectionTagName';
import InstituteTagMaster from './views/Institute/InstituteTagMaster';
import VideoContentUpload from './views/VideoContentUpload';
import InstituteVideoContentUpload from './views/Institute/InstituteVideoContentUpload';
import SectionVideoContentUpload from './views/section/SectionVideoContentUpload';
import UploadReferenceBook from './views/UploadReferenceBook';
import InstituteUploadReferenceBook from './views/Institute/InstituteUploadReferenceBook';
import SectionList from './views/Institute/SectionList';
import SectionUploadReferenceBook from './views/section/SectionUploadReferenceBook';
import AdminAnnouncements from './views/AdminAnnouncements';
import InstituteAnnouncements from './views/Institute/InstituteAnnouncements';
import SectionAnnouncements from './views/section/SectionAnnouncements';
import AdminAnnouncementView from './views/AdminAnnouncementView';
import SectionAnnouncementView from './views/section/SectionAnnouncementView';
import InstituteAnnouncementView from './views/Institute/InstituteAnnouncementView';
import ViewAllStudent from './views/section/ViewAllStudent';
import Print from './components/Print';
import AddStudent from './views/section/AddStudent';
import ForgetPassword from './components/ForgetPassword';
import UploadContentTextBook from './views/UploadContentTextBook';
import UpdateTextBook from './views/UpdateTextBook';
import ViewTextBook from './views/ViewTextBook';
import SectionUplaodTextBook from './views/section/SectionUplaodTextBook';
import SectionUpdateTextBook from './views/section/SectionUpdateTextBook';
import SectionViewTextBook from './views/section/SectionViewTextBook';
import CompetitiveExamMasterName from './views/CompetitiveExamMasterName';
import CompetitiveExamBookMaster from './views/CompetitiveExamBookMaster';
import CompetitiveExamLessonMaster from './views/CompetitiveExamLessonMaster';
import CompetitiveExamTopicMaster from './views/CompetitiveExamTopicMaster';
import CompetitiveExamSubtopicMaster from './views/CompetitiveExamSubtopicMaster';
import TextBookTopicMaster from './views/TextBookTopicMaster';
import TextBookSubtopicMaster from './views/TextBookSubtopicMaster';
import UploadVideo from './views/UploadVideo';
import ExamPattern from './views/ExamPattern';
import CompetitiveUploadQuestionBank from './views/CompetitiveUploadQuestionBank';
import CompetitiveExamUpdateQuestion from './views/CompetitiveExamUpdateQuestion';
import CompetitiveExamViewQuestion from './views/CompetitiveExamViewQuestion';
import InstituteCompetitiveExamMasterName from './views/Institute/InstituteCompetitiveExamMasterName';
import InstituteCompetitiveExamBookMaster from './views/Institute/InstituteCompetitiveExamBookMaster';
import ExamCreate from './views/section/ExamCreate';
import InstituteCompetitiveExamLessonMaster from './views/Institute/InstituteCompetitiveExamLessonMaster';
import InstituteCompetitiveExamTopicMaster from './views/Institute/InstituteCompetitiveExamTopicMaster';
import InstituteCompetitiveExamSubtopicMaster from './views/Institute/InstituteCompetitiveExamSubtopicMaster';
import InstituteUploadCompetitiveExam from './views/Institute/InstituteUploadCompetitveExam';
import InstituteUpdateCompetitiveExam from './views/Institute/InstituteUpdateCompetitiveExam';
import InstituteViewCompetitiveExam from './views/Institute/InstituteViewCompetitiveExam';
import { MyContext } from './components/MyContext';
import AssignExam from './views/section/AssignExam';
import SectionUploadVideo from './views/section/SectionUploadVideo';
import ListOfAssignedExam from './views/section/ListOfAssignedExam';
import SectionDetails from './views/Institute/SectionDetails';
import SectionInformation from './views/Institute/SectionInformation';
import StudyMaterialSummary from './views/Institute/StudyMaterialSummary';
import PrintSectionDetails from './components/PrintSectionDetails';
import UploadExam from './views/section/UploadExam';
import UploadPdfExam from './views/section/UploadPdfExam';
import PrintSectionInformation from './components/PrintSectionInformation';
import PrintStudyMaterialSummary from './components/PrintStudyMaterialSummary';
import InstituteVideoUplaod from './views/Institute/InstituteVideoUplaod';
import DailyPracticeTest from './views/section/DailyPracticeTest';
import SearchMaster from './views/SearchMaster';
import ClassReport from './views/section/ClassReport';
import CategoryReport from './views/section/CategoryReport';
import SubjectReport from './views/section/SubjectReport';
import TeacherReport from './views/section/TeacherReport';
import InstituteExamReportByDivision from './views/Institute/InstituteExamReportByDivision';
import InstituteExamReportByExamType from './views/Institute/InstituteExamReportByExamType';
import InstituteExamReportBySubject from './views/Institute/InstituteExamReportBySubject';
import InstituteExamReportByTeacher from './views/Institute/InstituteExamReportByTeacher';
import SectionExamReportByDivision from './views/section/SectionExamReportByDivision';
import SectionExamReportByExamType from './views/section/SectionExamReportByExamType';
import SectionExamReportBySubject from './views/section/SectionExamReportBySubject';
import SectionExamReportByTeacher from './views/section/SectionExamReportByTeacher';
import ExamDetails from './views/section/ExamDetails';
import TeacherExam from './views/section/TeacherExam';
import SyllabusStructureSubject from './views/SyllabusStructureSubject';
import TeacherExamView from './views/section/TeacherExamView';
import NotFound from './components/NotFound';
import CreateUser from './views/CreateUser';
import CreateManagementUser from './views/CreateManagementUser';
import SectionTeacherCredentials from './views/section/SectionTeacherCredentials';
import SectionTeachingPlan from './views/section/SectionTeachingPlan';
import SectionStudentCredentials from './views/section/SectionStudentCredentials';
import AcademicYear from './views/AcademicYear';
import UploadApp from './views/UploadApp';
import UploadedApps from './views/UploadedApps';
import SectionExportStudentDetails from './views/section/SectionExportStudentDetails';
import AppStoreUpdate from './views/AppStoreUpdate';
import SectionStudentReport from './views/section/SectionStudentReport';
import UpdateSectionDivision from './views/section/UpdateSectionDivision';
import SectionMappedAcademicYear from './views/section/SectionMappedAcademicYear';
import SectionDailyPresenty from './views/section/SectionDailyPresenty';
import SectionDailySchedule from './views/section/SectionDailySchedule';
import QuestionDetails from './views/QuestionDetails';
import SectionTeacherPerformance from './views/section/SectionTeacherPerformance';
import InstituteSectionTeacherPerformance from './views/Institute/InstituteSectionTeacherPerformance';
import SectionExamRequest from './views/section/SectionExamRequest';
import SectionStudentActivity from './views/section/SectionStudentActivity';
import AppVersionUpdate from './views/AppVersionUpdate';
import SectionStudentAttendance from './views/section/SectionStudentAttendance';
import WebsiteUnderMaintenance from './components/WebsiteUnderMaintenance';
import AIBasedTeachingPlan from './views/AIBasedTeachingPlan';
import StudentLocation from './views/StudentLocation';
import StudentCredentials from './views/StudentCredentials';
import TeacherCredentials from './views/TeacherCredentials';
import GenerateCouponCode from './views/GenerateCouponCode';
import StudentRandomExam from './views/section/StudentRandomExam';
import InstituteExamRequest from './views/Institute/InstituteExamRequest';

import CreateExam from './views/Exam/CreateExam';
import ExamUpload from './views/Exam/ExamUpload';
import AdminExamRequest from './views/AdminExamRequest';
import CreateHostelIncharge from './views/Institute/CreateHostelIncharge';
import HostelStudentInchargeMapping from './views/Institute/HostelStudentInchargeMapping';
import SectionCreateExamPaper from './views/section/SectionCreateExamPaper';
import SectionGenerateExamPaper from './views/section/SectionGenerateExamPaper';
import MigrateCompetitiveExamMasterName from './views/MigrateCompetitiveExamMasterName';
import TeacherHostedExam from './views/section/TeacherHostedExam';
import SectionTeacherDssReport from './views/section/SectionTeacherDssReport';
import SectionSubjectDssReport from './views/section/SectionSubjectDssReport';
import SectionStudyMaterialShow from './views/section/SectionStudyMaterialShow';
import SectionExamDownloadRequest from './views/section/SectionExamDownloadRequest';
import SectionExamDownloadReport from './views/section/SectionExamDownloadReport';
import SectionDashboardStudyMaterial from './views/section/SectionDashboardStudyMaterial';
import DashboardCompetitiveExam from './views/DashboardCompetitiveExam';
import DashboardStudyMaterial from './views/DashBoardStudyMaterial';
import DashboardQuestionBank from './views/DashboardQuestionBank';
import InstituteDashboardSectionList from './views/Institute/InstituteDashboardSectionList';
import InstituteDashboardStudentList from './views/Institute/InstituteDashboardStudentList';
import InstituteDashboardTeacherList from './views/Institute/InstituteDashboardTeacherList';
import InstituteDashboardStudyMaterial from './views/Institute/InstituteDashboardStudyMaterial';
import InstituteDashboardQuestionBank from './views/Institute/InstituteDashboardQuestionBank';
import SectionTeacherDssChatHistory from './views/section/SectionTeacherDssChatHistory';
import MigrateCompetitiveExamSubject from './views/MigrateCompetitiveExamSubject';
import TeacherUploadedVideo from './views/section/TeacherUploadedVideo';
import AIBasedTeachingReport from './views/AIBasedTeachingReport';
import AppInstituteSectionGradeMapping from './views/Institute/AppInstituteSectionGradeMapping';
import AppRegisteredStudentList from './views/AppRegisteredStudentList';
import MobileRegisterStudentList from './views/MobileRegisterStudentList';
import SectionDssComplain from './views/section/SectionDssComplain';
import DssPaymentReport from './views/DssPaymentReport';
import InstituteDssPaymentReport from './views/Institute/InstituteDssPaymentReport';
import AppSubscriptionCompleteStudentList from './views/AppSubscriptionCompleteStudentList';
import SubscriptionMaster from './views/SubscriptionMaster';
import MenuMaster from './views/MenuMaster';
import AboutUsAppMenu from './views/AboutUsAppMenu';
import InstituteSearchMaster from './views/Institute/InstituteSearchMaster';
import SectionSearchMaster from './views/section/SectionSearchMaster';
import AppSubscribedStudents from './views/AppSubscribedStudents';
import BlockSectionSubjects from './views/BlockSectionSubjects';
import DeviceDetails from './views/DeviceDetails';
import LiteracyVideos from './views/FLN/Literacy/LiteracyVideos';
import FlnTagMaster from './views/FlnTagMaster';
import LiteracyPdf from './views/FLN/Literacy/LiteracyPdf';
import LiteracyAudio from './views/FLN/Literacy/LiteracyAudio';
import LiteracyGame from './views/FLN/Literacy/LiteracyGame';
import PaperPattern from './views/PaperPattern';
import TestCopier from './views/section/TestCopier';


function App() {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  let instituteMasterId = localStorage.getItem("instituteMasterId");

  return (
    <MyContext.Provider value={{ sidebarToggle, setSidebarToggle }}>

      <AuthProvider>
        <SnackbarProvider>
          <Router>
            {/* <MaintenanceWrapper> */}
            <Routes>

              <Route path='/print' element={<Print />} />
              <Route path='/print-section-details' element={<PrintSectionDetails />} />
              <Route path='/print-section-information' element={<PrintSectionInformation />} />
              <Route path='/print-study-material-summary' element={<PrintStudyMaterialSummary />} />


              <Route element={<PrivateRoutes />}>
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/board' element={<BoardMaster />} />
                <Route path='/exam' element={<ExamMaster />} />
                <Route path='/grade' element={<GradeMaster />} />
                <Route path='/stream' element={<StreamMaster />} />
                <Route path='/course' element={<CourseMaster />} />
                <Route path='/question-type' element={<QuestionTypeMaster />} />
                <Route path='/subject' element={<SubjectMaster />} />
                <Route path='/publication' element={<PublicationMaster />} />
                <Route path='/syllabus-type' element={<SyllabusTypeMaster />} />
                <Route path='/tag-master' element={<TagMaster />} />
                <Route path='/fln-tag-master' element={<FlnTagMaster />} />
                <Route path='/academic-year' element={<AcademicYear />} />
                <Route path='/syllabus' element={<SyllabusMaster />} />
                <Route path='/syllabus-subject' element={<SyllabusStructureSubject />} />
                <Route path='/competitive-exam-book-master' element={<CompetitiveExamBookMaster />} />
                <Route path='/competitive-exam-master-name' element={<CompetitiveExamMasterName />} />
                <Route path='/menu-master' element={<MenuMaster />} />
                <Route path='/subscription' element={<SubscriptionMaster />} />
                <Route path='/about-us-app-menu' element={<AboutUsAppMenu />} />
                <Route path='/lesson' element={<LessonMaster />} />
                <Route path='/topic' element={<TopicMaster />} />
                <Route path='/sub-topic' element={<SubtopicMaster />} />
                <Route path='/upload-video' element={<UploadVideo />} />
                <Route path='/institutes' element={<InstituteMaster />} />
                <Route path='/pdf-book-uplaod' element={<UploadPdfBookMaster />} />
                {/* <Route path='/admin-all-student' element={<AdminAllStudent />} /> */}
                <Route path='/institute-list' element={<InstituteList />} />
                <Route path='/view-content-book' element={<ViewPdfBook />} />
                <Route path='/institute-grade-for-approval' element={<IntituteGradeForApproval />} />
                <Route path='/institute-subject-for-approval' element={<InstituteSubjectForApproval />} />
                <Route path='/video-content-upload' element={<VideoContentUpload />} />
                <Route path='/app-registered-students' element={<AppRegisteredStudentList />} />
                <Route path='/app-subscribed-students' element={<AppSubscribedStudents />} />
                <Route path='/app-subscription-report' element={<AppSubscriptionCompleteStudentList />} />
                <Route path='/dss-payment-report' element={<DssPaymentReport />} />
                <Route path='/upload-app' element={<UploadApp />} />
                <Route path='/uploaded-apps' element={<UploadedApps />} />
                <Route path='/app-store-update' element={<AppStoreUpdate />} />
                <Route path='/app-version-update' element={<AppVersionUpdate />} />
                <Route path='/create-user' element={<CreateUser />} />
                <Route path='/create-management-user' element={<CreateManagementUser />} />
                <Route path='/upload-reference-book' element={<UploadReferenceBook />} />
                <Route path='/admin-announcements' element={<AdminAnnouncements />} />
                <Route path='/admin-announcements-view' element={<AdminAnnouncementView />} />
                <Route path='/upload-text-book' element={<UploadContentTextBook />} />
                <Route path='/update-text-book' element={<UpdateTextBook />} />
                <Route path='/view-text-book' element={<ViewTextBook />} />
                {/* <Route path='/migrate-competitive-exam-master-name' element={<MigrateCompetitiveExamMasterName />} /> */}
                <Route path='/migrate-competitive-exam-subject' element={<MigrateCompetitiveExamSubject />} />
                <Route path='/competitive-exam-lesson' element={<CompetitiveExamLessonMaster />} />
                <Route path='/competitive-exam-topic' element={<CompetitiveExamTopicMaster />} />
                <Route path='/competitive-exam-sub-topic' element={<CompetitiveExamSubtopicMaster />} />
                <Route path='/text-book-topic' element={<TextBookTopicMaster />} />
                <Route path='/text-book-sub-topic' element={<TextBookSubtopicMaster />} />
                <Route path='/exam-pattern' element={<ExamPattern />} />
                <Route path='/paper-pattern' element={<PaperPattern />} />
                <Route path='/competitive-exam-upload-question' element={<CompetitiveUploadQuestionBank />} />
                <Route path='/competitive-exam-update-question' element={<CompetitiveExamUpdateQuestion />} />
                <Route path='/competitive-exam-view-question' element={<CompetitiveExamViewQuestion />} />
                <Route path='/ai-based-teaching-plan' element={<AIBasedTeachingPlan />} />
                <Route path='/ai-based-teaching-report' element={<AIBasedTeachingReport />} />
                <Route path='/question-details' element={<QuestionDetails />} />
                <Route path='/search-master' element={<SearchMaster />} />
                <Route path='/teacher-credentials' element={<TeacherCredentials />} />
                <Route path='/student-credentials' element={<StudentCredentials />} />
                <Route path='/student-location' element={<StudentLocation />} />
                <Route path='/generate-coupon-code' element={<GenerateCouponCode />} />
                <Route path='/admin-exam-request' element={<AdminExamRequest />} />
                <Route path='/block-section-subjects' element={<BlockSectionSubjects />} />
                <Route path='/device-details' element={<DeviceDetails />} />

                {/* Admin dashboard routes */}
                <Route path='/mobile-register-student-list' element={<MobileRegisterStudentList />} />
                <Route path='/dashboard-competitve-exam' element={<DashboardCompetitiveExam />} />
                <Route path='/dashboard-study-material' element={<DashboardStudyMaterial />} />
                <Route path='/dashboard-question-bank' element={<DashboardQuestionBank />} />

                {/* Admin FLN Routes */}
                <Route path='/fln-literacy-videos' element={<LiteracyVideos />} />
                <Route path='/fln-literacy-pdfs' element={<LiteracyPdf />} />
                <Route path='/fln-literacy-audio' element={<LiteracyAudio />} />
                <Route path='/fln-literacy-games' element={<LiteracyGame />} />

                <Route path='/fln-numeracy-videos' element={<LiteracyVideos />} />
                <Route path='/fln-numeracy-games' element={<LiteracyVideos />} />
                <Route path='/fln-numeracy-games' element={<LiteracyVideos />} />
                <Route path='/fln-numeracy-games' element={<LiteracyVideos />} />


              </Route>

              <Route element={<InstitutePrivateRoutes />}>
                <Route path='/institute-dashboard' element={<InstituteDashboard />} />
                <Route element={<InstitutePrivateAppRoutes />}>
                  <Route path='/app-institute-section-grade-mapping' element={<AppInstituteSectionGradeMapping />} />
                  <Route path='/institute-dss-payment-report' element={<InstituteDssPaymentReport />} />
                </Route>
                <Route path='/institute-grade-master' element={<InstituteGradeMaster />} />
                <Route path='/institute-division-master' element={<InstituteDivisionMaster />} />
                <Route path='/institute-subject-master' element={<InstituteSubjectMaster />} />
                <Route path='/institute-tag-master' element={<InstituteTagMaster />} />
                <Route path='/institute-section-master' element={<SectionMaster />} />
                <Route path='/institute-syllabus-structure' element={<InstituteSyllabusStructrure />} />
                <Route path='/institute-pdf-uploader' element={<InstitutePdfUpload />} />
                <Route path='/institute-lesson' element={<InstituteLessonMaster />} />
                <Route path='/institute-topic' element={<InstituteTopicMaster />} />
                <Route path='/institute-sub-topic' element={<InstituteSubTopicMaster />} />
                <Route path='/institute-view-content-book' element={<InstituteViewPdfBook />} />
                <Route path='/institute-update-text-book' element={<InstituteUpdateTextBook />} />
                <Route path='/institute-view-text-book' element={<InstituteViewTextBook />} />
                <Route path='/institute-upload-text-book' element={<InstituteUploadContentTextBook />} />
                <Route path='/institute-upload-competitive-exam' element={<InstituteUploadCompetitiveExam />} />
                <Route path='/institute-update-competitive-exam' element={<InstituteUpdateCompetitiveExam />} />
                <Route path='/institute-view-competitive-exam' element={<InstituteViewCompetitiveExam />} />
                <Route path='/institute-text-book-video-content-upload' element={<InstituteVideoContentUpload />} />
                <Route path='/institute-upload-reference-book' element={<InstituteUploadReferenceBook />} />
                <Route path='/institute-announcements' element={<InstituteAnnouncements />} />
                <Route path='/institute-announcements-view' element={<InstituteAnnouncementView />} />
                <Route path='/section-list' element={<SectionList />} />
                <Route path='/Institute-competitive-exam-name-master' element={<InstituteCompetitiveExamMasterName />} />
                <Route path='/Institute-competitive-exam-book-master' element={<InstituteCompetitiveExamBookMaster />} />
                <Route path='/institute-competitive-exam-lesson' element={<InstituteCompetitiveExamLessonMaster />} />
                <Route path='/institute-competitive-exam-topic' element={<InstituteCompetitiveExamTopicMaster />} />
                <Route path='/institute-competitive-exam-sub-topic' element={<InstituteCompetitiveExamSubtopicMaster />} />
                <Route path='/institute-video-upload' element={<InstituteVideoUplaod />} />
                {/* <Route path='/institute-section-details' element={<SectionDetails />} /> */}
                {/* <Route path='/institute-section-information' element={<SectionInformation />} /> */}
                {/* <Route path='/institute-study-material-summary' element={<StudyMaterialSummary />} /> */}
                <Route path='/institute-exam-request' element={<InstituteExamRequest />} />
                <Route path='/institute-exam-report-by-division' element={<InstituteExamReportByDivision />} />
                <Route path='/institute-exam-report-by-exam-type' element={<InstituteExamReportByExamType />} />
                <Route path='/institute-exam-report-by-subject' element={<InstituteExamReportBySubject />} />
                <Route path='/institute-exam-report-by-teacher' element={<InstituteExamReportByTeacher />} />
                <Route path='/institute-section-teacher-performance' element={<InstituteSectionTeacherPerformance />} />
                <Route path='/section-create-hostel-incharge' element={<CreateHostelIncharge />} />
                <Route path='/section-student-hostel-incharge-mapping' element={<HostelStudentInchargeMapping />} />

                {/* Dashboard Route */}
                <Route path='/institute-dashboard-section-list' element={<InstituteDashboardSectionList />} />
                <Route path='/institute-dashboard-student-list' element={<InstituteDashboardStudentList />} />
                <Route path='/institute-dashboard-teacher-list' element={<InstituteDashboardTeacherList />} />
                <Route path='/institute-dashboard-study-material-list' element={<InstituteDashboardStudyMaterial />} />
                <Route path='/institute-dashboard-question-bank' element={<InstituteDashboardQuestionBank />} />
                <Route path='/institute-search-master' element={<InstituteSearchMaster />} />
              </Route>

              <Route element={<SectionPrivateRoutes />}>
                <Route path='/section-dashboard' element={<SectionDashboard />} />
                <Route path='/section-mapped-academic-year' element={<SectionMappedAcademicYear />} />
                <Route path='/section-teacher-section' element={<TeacherMaster />} />
                <Route path='/section-teacher-mapping' element={<TeacherMapping />} />
                <Route path='/section-import-student' element={<ImportStudent />} />
                <Route path='/non-approved-student' element={<UnaprovedStudentList />} />
                <Route path='/section-syllabus-structure' element={<SectionSyllabusStructure />} />
                <Route path='/section-upload-pdf' element={<SectionUploadPdfMaster />} />
                <Route path='/section-all-student-list' element={<SectionAllStudentList />} />
                <Route path='/section-update-student-division' element={<UpdateSectionDivision />} />
                <Route path='/section-lesson' element={<SectionLessonMaster />} />
                <Route path='/section-topic' element={<SectionTopicMaster />} />
                <Route path='/section-sub-topic' element={<SectionSubtopicMaster />} />
                <Route path='/section-video-upload' element={<SectionUploadVideo />} />
                <Route path='/section-view-content-book' element={<SectionViewPdfBook />} />
                <Route path='/section-tag-master' element={<SectionTagMaster />} />
                <Route path='/section-export-student-details' element={<SectionExportStudentDetails />} />
                <Route path='/section-video-content-upload' element={<SectionVideoContentUpload />} />
                <Route path='/section-study-material-show' element={<SectionStudyMaterialShow />} />
                <Route path='/section-upload-refrence-book' element={<SectionUploadReferenceBook />} />
                <Route path='/section-announcements' element={<SectionAnnouncements />} />
                <Route path='/section-announcements-view' element={<SectionAnnouncementView />} />
                <Route path='/view-all-student' element={<ViewAllStudent />} />
                <Route path='/add-student' element={<AddStudent />} />
                <Route path='/section-upload-text-book' element={<SectionUplaodTextBook />} />
                <Route path='/section-update-text-book' element={<SectionUpdateTextBook />} />
                <Route path='/section-view-text-book' element={<SectionViewTextBook />} />
                <Route path='/test-copier' element={<TestCopier />} />
                <Route path='/exam-create' element={<ExamCreate />} />
                <Route path='/assign-exam' element={<AssignExam />} />
                <Route path='/list-of-assigned-exam' element={<ListOfAssignedExam />} />
                <Route path='/upload-exam' element={<UploadExam />} />
                <Route path='/upload-pdf-exam' element={<UploadPdfExam />} />
                <Route path='/create-exam-paper' element={<SectionCreateExamPaper />} />
                <Route path='/generate-exam-paper' element={<SectionGenerateExamPaper />} />
                <Route path='/exam-details' element={<ExamDetails />} />
                <Route path='/teacher-hosted-exam-details' element={<TeacherHostedExam />} />
                <Route path='/daily-practice-test' element={<DailyPracticeTest />} />
                <Route path='/class-report' element={<ClassReport />} />
                <Route path='/category-report' element={<CategoryReport />} />
                <Route path='/subject-report' element={<SubjectReport />} />
                <Route path='/teacher-report' element={<TeacherReport />} />
                <Route path='/teacher-exam' element={<TeacherExam />} />
                <Route path='/teacher-exam-view' element={<TeacherExamView />} />
                <Route path='/section-teacher-credentials' element={<SectionTeacherCredentials />} />
                <Route path='/section-teaching-plan' element={<SectionTeachingPlan />} />
                <Route path='/section-teacher-uploaded-video' element={<TeacherUploadedVideo />} />
                <Route path='/section-student-credentials' element={<SectionStudentCredentials />} />
                <Route path='/section-student-attendance' element={<SectionStudentAttendance />} />
                <Route path='/student-report' element={<SectionStudentReport />} />
                <Route path='/section-daily-presenty' element={<SectionDailyPresenty />} />
                <Route path='/section-daily-schedule' element={<SectionDailySchedule />} />
                <Route path='/section-teacher-performance' element={<SectionTeacherPerformance />} />
                <Route path='/section-exam-request' element={<SectionExamRequest />} />
                <Route path='/section-exam-download-request' element={<SectionExamDownloadRequest />} />
                <Route path='/section-student-activity' element={<SectionStudentActivity />} />
                <Route path='/section-exam-report-by-division' element={<SectionExamReportByDivision />} />
                <Route path='/section-exam-report-by-exam-type' element={<SectionExamReportByExamType />} />
                <Route path='/section-exam-report-by-subject' element={<SectionExamReportBySubject />} />
                <Route path='/section-exam-report-by-teacher' element={<SectionExamReportByTeacher />} />
                <Route path='/section-exam-download-report' element={<SectionExamDownloadReport />} />
                <Route path='/student-random-exam' element={<StudentRandomExam />} />
                <Route path='/section-teacher-dss-report' element={<SectionTeacherDssReport />} />
                <Route path='/section-teacher-dss-chat-history' element={<SectionTeacherDssChatHistory />} />
                <Route path='/section-subject-dss-report' element={<SectionSubjectDssReport />} />
                <Route path='/section-search-master' element={<SectionSearchMaster />} />
                {/* <Route path='/section-dss-report-complain' element={<SectionDssComplain />} /> */}
                <Route element={<SectionPrivateAppRoutes />}>
                  <Route path='/section-dss-report-complain' element={<SectionDssComplain />} />
                </Route>




                <Route path='/create-exam' element={<CreateExam />} />
                <Route path='/exam-upload' element={<ExamUpload />} />

                {/* Dashboard Route */}
                <Route path='/section-register-teacher-list' element={<RegisterTeacherList />} />
                <Route path='/section-dashboard-study-material' element={<SectionDashboardStudyMaterial />} />
              </Route>

              <Route element={<AuthRoute />}>
                <Route path='/' element={<Login />} />
                <Route path='/institute' element={<InstituteLogin />} />
                <Route path='/section' element={<SectionLogin />} />
                <Route path='/foget-password' element={<ForgetPassword />} />
              </Route>

              <Route path="*" element={<NotFound />} />
              {/* <Route path="*" element={<WebsiteUnderMaintenance />} /> */}

            </Routes>
            {/* </MaintenanceWrapper> */}
          </Router>
        </SnackbarProvider>
      </AuthProvider>

    </MyContext.Provider>

  );
}
const PrivateRoutes = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  return (
    auth && userType === "A" ? <><Sidebar /> <Outlet /> </> : <Navigate to='/' />
  )
}

const InstitutePrivateRoutes = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  return (
    auth && userType === "I" ? <><InstituteSidebar /> <Outlet /> </> : <Navigate to='/institute' />
  )
}

const InstitutePrivateAppRoutes = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  let instituteMasterId = localStorage.getItem("instituteMasterId");
  return (
    auth && userType === "I" && instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID ? <><Outlet /> </> : <Navigate to='/institute' />
  )
}

const SectionPrivateRoutes = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  return (
    auth && userType === "B" ? <><SectionSidebar /> <Outlet /> </> : <Navigate to='/section' />
  )
}

const SectionPrivateAppRoutes = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  let instituteMasterId = localStorage.getItem("instituteMasterId");
  return (
    auth && userType === "B" && instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID ? <><Outlet /> </> : <Navigate to='/section' />
  )
}

const AuthRoute = () => {
  let auth = localStorage.getItem("accessToken")
  let userType = localStorage.getItem("userType")
  // return (
  //   auth && userType === "A" ? <Navigate to='/dashboard' /> : <Outlet />
  // )
  if (auth && userType === "A") {
    return (
      <Navigate to='/dashboard' />
    )
  } else if (auth && userType === "I") {
    return (
      <Navigate to='/institute-dashboard' />
    )
  } else if (auth && userType === "B") {
    return (
      <Navigate to='/section-dashboard' />
    )
  } else {
    return (
      <Outlet />
    )
  }
}


export default App;
